import {
  capitalizeFirstLetter,
  formatDateOnly,
  isFieldEmptyAndInOverview
} from 'utils/helpers';
import {
  WithIncomeChildI,
  WithIncomeFamilyI
} from '../../../../../types/interface';
import { t } from 'i18next';
import StandardInput from 'base/StandardInput/StandardInput';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import StandardCheckbox from 'base/StandardCheckbox/StandardCheckbox';
import { StandardImageUpload } from 'base/StandardImageUpload/StandardImageUpload';
import { StandardCurrency } from 'base/StandardCurrency/StandardCurrency';

export const WithIncome = ({
  formDataChildren,
  formDataFamily
}: {
  formDataChildren: WithIncomeChildI[];
  formDataFamily: WithIncomeFamilyI[];
}) => {
  const disabled = true;
  const showError = false;
  return (
    <div id="with_household">
      <div className="container-fluid ">
        <ConditionalRender
          condition={formDataFamily.length > 0 || formDataChildren.length > 0}
        >
          <div className="row">
            <div className="col-12 my-3">
              <h1 className="text-center">
                {capitalizeFirstLetter(t('overview.general.text_3'))}
              </h1>
            </div>
            <div className="col-12 col-lg-6">
              <div className="row">
                <h4 className="col-6 pb-3">
                  {capitalizeFirstLetter(
                    t('basic_data.with_income.general.text_1')
                  )}
                </h4>
                <div className="col-6">
                  <StandardInput
                    className={`${isFieldEmptyAndInOverview(
                      true,
                      true
                    )} form-control-icon`}
                    placeholder={t(
                      'basic_data.with_income.placeholder.text_15'
                    )}
                    value={formDataFamily.length}
                    showError={false}
                    disabled={true}
                    onChange={() => {}}
                    id=""
                    label={t('basic_data.with_income.placeholder.text_1')}
                    type=""
                    validations={[]}
                  />
                </div>
              </div>
              <ConditionalRender condition={formDataFamily.length > 0}>
                {formDataFamily?.map((item, index) => {
                  return (
                    <div
                      className={`mb-3`}
                      key={`with-household-family-${index}`}
                    >
                      <div className="row">
                        <ConditionalRender condition={index !== 0}>
                          <div className="col-12">
                            <hr />
                          </div>
                          <div className="col-12 fs-16 fw-black text-center pb-3">
                            {capitalizeFirstLetter(
                              t('basic_data.without_income.general.text_4')
                            )}
                          </div>
                        </ConditionalRender>
                      </div>
                      <div className="row">
                        <StandardInput
                          disabled={index === 0 ? true : disabled}
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.first_name
                          )} col-12  ${index === 0 ? 'col-md-6' : 'col-md-4'}`}
                          placeholder={t('general.common_text.text_5')}
                          label={t('general.common_text.text_5')}
                          value={item.first_name}
                          showError={showError}
                          validations={[]}
                          onChange={() => {}}
                        />
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.last_name
                          )} col-12  ${index === 0 ? 'col-md-6' : 'col-md-4'}`}
                          placeholder={t('general.common_text.text_6')}
                          disabled={index === 0 ? true : disabled}
                          label={t('general.common_text.text_6')}
                          value={item.last_name}
                          showError={showError}
                          validations={[]}
                          onChange={() => {}}
                        />
                        <ConditionalRender condition={index !== 0}>
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.birth_date
                            )} form-control-icon col-12 col-md-6 col-lg-4`}
                            placeholder={t(
                              'register_applicant.placeholder.birthDate'
                            )}
                            disabled={disabled}
                            value={formatDateOnly(item.birth_date)}
                            showError={showError}
                            validations={[]}
                            label={t(
                              'register_applicant.placeholder.birthDate'
                            )}
                            onChange={() => {}}
                            type=""
                          />
                        </ConditionalRender>
                      </div>
                      <ConditionalRender condition={index !== 0}>
                        <div className="row">
                          <StandardInput
                            type="text"
                            disabled={disabled}
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.street
                            )} form-control-icon col-12`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_5'
                            )}
                            label={t(
                              'basic_data.with_income.placeholder.text_5'
                            )}
                            value={item.street}
                            showError={showError}
                            validations={[]}
                            onChange={() => {}}
                          />
                        </div>
                        <div className="row">
                          <StandardInput
                            type="number"
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.zip_code
                            )} form-control-icon col-12 col-lg-4`}
                            placeholder={t(
                              'register_applicant.placeholder.zip'
                            )}
                            disabled={disabled}
                            label={t('register_applicant.placeholder.zip')}
                            value={item.zip_code as number}
                            maxLength={4}
                            showError={showError}
                            validations={[]}
                            onChange={() => {}}
                          />
                          <StandardInput
                            type="text"
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.location
                            )} form-control-icon col-12 col-lg-4`}
                            placeholder={t(
                              'basic_data.without_income.left.placeholder.Ort (Privat)'
                            )}
                            disabled={disabled}
                            onChange={() => {}}
                            label={t(
                              'basic_data.without_income.left.placeholder.Ort (Privat)'
                            )}
                            value={item.location}
                            showError={showError}
                            validations={[]}
                          />
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item?.registration_form_file
                            )} col-12 col-lg-4`}
                            value={item?.registration_form_file}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.without_income.left.attachment.text_1'
                            )}
                            showError={showError}
                            validations={[]}
                            label={t(
                              'basic_data.without_income.left.attachment.text_1'
                            )}
                          />
                        </div>
                      </ConditionalRender>
                      <div className="row">
                        <div className="col-12 fw-black fs-16  ">
                          {capitalizeFirstLetter(
                            t('basic_data.with_income.general.text_2')
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <StandardCurrency
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.net_income_eur
                          )} form-control-icon col-12 col-md-6 col-lg-4`}
                          placeholder={t(
                            'basic_data.with_income.placeholder.text_10'
                          )}
                          onChange={() => {}}
                          label={t(
                            'basic_data.with_income.placeholder.text_10'
                          )}
                          value={item.net_income_eur as number}
                          showError={showError}
                          disabled={disabled}
                          validations={[]}
                          type=""
                        />
                        <StandardImageUpload
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.pay_slip_file
                          )} col-12 col-md-6 col-lg-4`}
                          value={item.pay_slip_file!}
                          disabled={!disabled}
                          imageText={t(
                            'basic_data.with_income.attachment.text_2'
                          )}
                          showError={
                            (!item.pension_notice_file &&
                              !item.confirmation_of_co_insurance_file) ||
                            (index === 0 &&
                              item.net_income_eur &&
                              item.net_income_eur > 0)
                              ? showError
                              : false
                          }
                          validations={[]}
                          label={t('basic_data.with_income.attachment.text_2')}
                        />
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.pay_slip_date_proof
                          )} col-12 col-md-6 col-lg-4`}
                          placeholder={t(
                            'basic_data.with_income.placeholder.text_4'
                          )}
                          value={formatDateOnly(
                            item.pay_slip_date_proof as Date
                          )}
                          disabled={disabled}
                          showError={false}
                          validations={[]}
                          label={t('basic_data.with_income.placeholder.text_4')}
                          onChange={() => {}}
                          type=""
                        />
                      </div>
                      <ConditionalRender condition={index !== 0}>
                        <div className="row">
                          <div className="col-4"></div>
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.pension_notice_file
                            )} col-12 col-lg-4`}
                            value={item.pension_notice_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_3'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_3'
                            )}
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.pension_notice_date_proof
                            )} form-control-icon col-12 col-lg-4`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            value={formatDateOnly(
                              item.pension_notice_date_proof as Date
                            )}
                            disabled={disabled}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            onChange={() => {}}
                            type=""
                          />
                        </div>
                        <div className="row">
                          <div className="col-4"></div>
                          <StandardImageUpload
                            value={item.confirmation_of_co_insurance_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_4'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_4'
                            )}
                            className="col-12 col-md-4"
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.confirmation_of_co_insurance_date_proof
                            )} form-control-icon col-12 col-md-4`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            value={formatDateOnly(
                              item.confirmation_of_co_insurance_date_proof as Date
                            )}
                            disabled={disabled}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            onChange={() => {}}
                            type=""
                          />
                        </div>
                      </ConditionalRender>
                      <div className="row">
                        <StandardCurrency
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.additional_income_eur
                          )} form-control-icon col-12 col-md-4`}
                          placeholder={t(
                            'basic_data.with_income.placeholder.text_11'
                          )}
                          onChange={() => {}}
                          label={t(
                            'basic_data.with_income.placeholder.text_11'
                          )}
                          disabled={disabled}
                          value={item.additional_income_eur as number}
                          showError={showError}
                          validations={[]}
                          type=""
                        />
                        <StandardImageUpload
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.proof_of_income_or_income_tax_notice_file
                          )} col-12 col-md-4`}
                          value={
                            item.proof_of_income_or_income_tax_notice_file!
                          }
                          disabled={!disabled}
                          imageText={t(
                            'basic_data.with_income.attachment.text_5'
                          )}
                          showError={
                            item.additional_income_eur! > 0 ? showError : false
                          }
                          validations={[]}
                          label={t('basic_data.with_income.attachment.text_5')}
                        />
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.proof_of_income_or_income_tax_notice_date_proof
                          )} form-control-icon col-12 col-md-4`}
                          placeholder={t(
                            'basic_data.with_income.placeholder.text_4'
                          )}
                          disabled={disabled}
                          value={formatDateOnly(
                            item.proof_of_income_or_income_tax_notice_date_proof as Date
                          )}
                          showError={
                            item.additional_income_eur! > 0 ? showError : false
                          }
                          validations={[]}
                          label={t('basic_data.with_income.placeholder.text_4')}
                          onChange={() => {}}
                          type=""
                        />
                      </div>
                      <div className="d-flex gap-2 align-items-center">
                        <StandardCheckbox
                          className=""
                          disabled
                          isChecked={formDataChildren.length > 0}
                          label={t('basic_data.with_income.checkbox.text_1')}
                          setChecked={() => {}}
                        />
                      </div>
                      <ConditionalRender
                        condition={formDataChildren.length > 0}
                      >
                        <div className="row">
                          <StandardCurrency
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.childcare_allowance_eur
                            )} form-control-icon col-12 col-md-4`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_12'
                            )}
                            onChange={() => {}}
                            label={t(
                              'basic_data.with_income.placeholder.text_12'
                            )}
                            value={item.childcare_allowance_eur as number}
                            showError={false}
                            disabled={disabled}
                            validations={[]}
                            type=""
                          />

                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.proof_of_child_allowance_file
                            )} form-control-icon col-12 col-md-4`}
                            value={item.proof_of_child_allowance_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_6'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_6'
                            )}
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.proof_of_child_allowance_date_proof
                            )} form-control-icon col-12 col-md-4`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            value={formatDateOnly(
                              item.proof_of_child_allowance_date_proof as Date
                            )}
                            disabled={disabled}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            onChange={() => {}}
                            type=""
                          />
                        </div>
                        <div className="row">
                          <StandardCurrency
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.family_bonus_eur
                            )} form-control-icon col-12 col-md-4`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_13'
                            )}
                            onChange={() => {}}
                            label={t(
                              'basic_data.with_income.placeholder.text_13'
                            )}
                            value={item.family_bonus_eur as number}
                            showError={showError}
                            disabled={disabled}
                            validations={[]}
                            type=""
                          />
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.family_bonus_file
                            )} form-control-icon col-12 col-md-4`}
                            value={item.family_bonus_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.without_income.left.attachment.text_3'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.without_income.left.attachment.text_3'
                            )}
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.family_bonus_date_proof
                            )} form-control-icon col-12 col-md-4`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            value={formatDateOnly(
                              item.family_bonus_date_proof as Date
                            )}
                            disabled={disabled}
                            showError={showError}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            validations={[]}
                            onChange={() => {}}
                            type=""
                          />
                        </div>
                        <div className="row">
                          <StandardCheckbox
                            label={t('basic_data.with_income.checkbox.text_2')}
                            disabled={disabled}
                            isChecked={item.parent_live_separately as boolean}
                            setChecked={() => {}}
                            formGroupClassName="checkbox-margin-class col-12 col-md-12"
                          />
                        </div>
                        <ConditionalRender
                          condition={
                            item.parent_live_separately! && index === 0
                          }
                        >
                          {item?.parent_seprately?.map(
                            (user_parent_detail, index) => {
                              return (
                                <div className="" key={`parent-child-${index}`}>
                                  <ConditionalRender
                                    condition={index > 0 && !disabled}
                                  >
                                    <div className="row justify-content-end">
                                      <div>
                                        <hr />
                                      </div>
                                    </div>
                                  </ConditionalRender>
                                  <div className="row">
                                    <ConditionalRender
                                      condition={item.parent_live_separately!}
                                    >
                                      <StandardCurrency
                                        className={`${isFieldEmptyAndInOverview(
                                          true,
                                          !!user_parent_detail.alimony_amount
                                        )} form-control-icon col-12 col-md-6`}
                                        placeholder={t(
                                          'basic_data.with_income.placeholder.text_14'
                                        )}
                                        onChange={() => {}}
                                        label={t(
                                          'basic_data.with_income.placeholder.text_14'
                                        )}
                                        value={
                                          user_parent_detail.alimony_amount as number
                                        }
                                        showError={showError}
                                        validations={[]}
                                        disabled={disabled}
                                        type=""
                                      />
                                      <div className="d-flex col-12 col-md-6 gap-3">
                                        <StandardCheckbox
                                          isChecked={user_parent_detail.paid}
                                          disabled={disabled}
                                          className="checkbox-margin-class"
                                          label={t(
                                            'basic_data.with_income.checkbox.text_4'
                                          )}
                                          setChecked={() => {}}
                                        />
                                        <StandardCheckbox
                                          isChecked={
                                            user_parent_detail.received
                                          }
                                          className="checkbox-margin-class"
                                          label={t(
                                            'basic_data.with_income.checkbox.text_3'
                                          )}
                                          disabled={disabled}
                                          setChecked={() => {}}
                                        />
                                      </div>
                                    </ConditionalRender>
                                  </div>
                                  <div className="row">
                                    <ConditionalRender
                                      condition={item.parent_live_separately!}
                                    >
                                      <div className="col-12 col-md-4"></div>
                                      <div className="col-12 col-md-4">
                                        <StandardImageUpload
                                          value={
                                            user_parent_detail.alimentation_payment_file!
                                          }
                                          disabled={!disabled}
                                          imageText={t(
                                            'basic_data.with_income.attachment.text_7'
                                          )}
                                          showError={showError}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.attachment.text_7'
                                          )}
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.alimentation_payment_file
                                          )}`}
                                        />
                                      </div>
                                      <div className=" col-12 col-md-4">
                                        <StandardInput
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.alimentation_payment_date_proof
                                          )}`}
                                          placeholder={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          value={formatDateOnly(
                                            user_parent_detail.alimentation_payment_date_proof as Date
                                          )}
                                          disabled={disabled}
                                          showError={false}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          onChange={() => {}}
                                          type=""
                                        />
                                      </div>
                                    </ConditionalRender>
                                  </div>
                                  <div className="row">
                                    <ConditionalRender
                                      condition={item.parent_live_separately!}
                                    >
                                      <div className="col-12 col-md-4"></div>
                                      <div className="col-12 col-md-4">
                                        <StandardImageUpload
                                          value={
                                            user_parent_detail.alimentation_payment_file_1!
                                          }
                                          disabled={!disabled}
                                          imageText={t(
                                            'basic_data.with_income.attachment.text_30'
                                          )}
                                          showError={showError}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.attachment.text_30'
                                          )}
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.alimentation_payment_file_1
                                          )}`}
                                        />
                                      </div>
                                      <div className=" col-12 col-md-4">
                                        <StandardInput
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.alimentation_payment_date_proof_1
                                          )}`}
                                          placeholder={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          value={formatDateOnly(
                                            user_parent_detail.alimentation_payment_date_proof_1 as Date
                                          )}
                                          disabled={disabled}
                                          showError={false}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          onChange={() => {}}
                                          type=""
                                        />
                                      </div>
                                    </ConditionalRender>
                                  </div>
                                  <div className="row">
                                    <ConditionalRender
                                      condition={item.parent_live_separately!}
                                    >
                                      <div className="col-12 col-md-4"></div>
                                      <div className="col-12 col-md-4">
                                        <StandardImageUpload
                                          value={
                                            user_parent_detail.alimentation_payment_file_2!
                                          }
                                          disabled={!disabled}
                                          imageText={t(
                                            'basic_data.with_income.attachment.text_31'
                                          )}
                                          showError={showError}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.attachment.text_31'
                                          )}
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.alimentation_payment_file_2
                                          )}`}
                                        />
                                      </div>
                                      <div className=" col-12 col-md-4">
                                        <StandardInput
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.alimentation_payment_date_proof_2
                                          )}`}
                                          placeholder={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          value={formatDateOnly(
                                            user_parent_detail.alimentation_payment_date_proof_2 as Date
                                          )}
                                          disabled={disabled}
                                          showError={false}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          onChange={() => {}}
                                          type=""
                                        />
                                      </div>
                                    </ConditionalRender>
                                  </div>
                                  <div className="row">
                                    <ConditionalRender
                                      condition={item.parent_live_separately!}
                                    >
                                      <div className="col-12 col-md-4"></div>
                                      <div className="col-12 col-md-4">
                                        <StandardImageUpload
                                          value={
                                            user_parent_detail.decision_file!
                                          }
                                          disabled={!disabled}
                                          imageText={t(
                                            'basic_data.with_income.attachment.text_8'
                                          )}
                                          showError={showError}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.attachment.text_8'
                                          )}
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.decision_file
                                          )}`}
                                        />
                                      </div>
                                      <div className="col-12 col-md-4">
                                        <StandardInput
                                          className={`${isFieldEmptyAndInOverview(
                                            true,
                                            !!user_parent_detail.decision_date_proof
                                          )}`}
                                          placeholder={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          value={formatDateOnly(
                                            user_parent_detail.decision_date_proof as Date
                                          )}
                                          disabled={disabled}
                                          showError={false}
                                          validations={[]}
                                          label={t(
                                            'basic_data.with_income.placeholder.text_4'
                                          )}
                                          onChange={() => {}}
                                          type=""
                                        />
                                      </div>
                                    </ConditionalRender>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </ConditionalRender>
                      </ConditionalRender>
                    </div>
                  );
                })}
              </ConditionalRender>
              <ConditionalRender condition={!disabled}>
                <div className="fs-16 fw-black">
                  {t('basic_data.with_income.general.text_9')}
                </div>
              </ConditionalRender>
            </div>
            <div className="col-12 col-lg-6">
              <div className="row">
                <div className="col-6">
                  <StandardInput
                    className={` form-control-icon`}
                    placeholder={t(
                      'basic_data.with_income.placeholder.text_15'
                    )}
                    value={
                      formDataChildren.filter(f => !f.live_separately).length
                    }
                    showError={false}
                    disabled={true}
                    onChange={() => {}}
                    label={t('basic_data.with_income.placeholder.text_15')}
                    type=""
                    validations={[]}
                  />
                </div>
                <div className="col-6">
                  <StandardInput
                    placeholder=""
                    validations={[]}
                    className="form-control-icon"
                    label={t('basic_data.with_income.placeholder.text_16')}
                    value={
                      formDataChildren.filter(f => f.live_separately).length
                    }
                    showError={false}
                    disabled={true}
                    onChange={() => {}}
                    type="number"
                  />
                </div>
              </div>
              <ConditionalRender condition={formDataChildren.length > 0}>
                {formDataChildren.map((item, index) => {
                  return (
                    <div
                      key={`with-household-family-${index}`}
                      className={`mb-3 `}
                    >
                      <div className="row">
                        <ConditionalRender condition={index > 0}>
                          <div className="col-12">
                            <hr />
                          </div>
                        </ConditionalRender>
                        <div className="col-12 mb-3">
                          <h5>{t('basic_data.with_income.general.text_4')}</h5>
                        </div>
                        <ConditionalRender
                          condition={item.live_separately || false}
                        >
                          <div className="col-12 fs-16 fw-black text-center pb-3">
                            {capitalizeFirstLetter(
                              t(
                                'basic_data.with_income.live_saperately_heading'
                              )
                            )}
                          </div>
                        </ConditionalRender>
                      </div>
                      <div className="row">
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.first_name
                          )} form-control-icon col-12 col-md-6`}
                          placeholder={t('general.common_text.text_5')}
                          disabled={disabled}
                          label={t('general.common_text.text_5')}
                          value={item.first_name}
                          showError={showError}
                          onChange={() => {}}
                          validations={[]}
                        />
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.last_name
                          )} form-control-icon col-12 col-md-6`}
                          disabled={disabled}
                          placeholder={t('general.common_text.text_6')}
                          label={t('general.common_text.text_6')}
                          value={item.last_name}
                          showError={showError}
                          onChange={() => {}}
                          validations={[]}
                        />
                      </div>
                      <div className="row">
                        <StandardImageUpload
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.birth_certificate_file
                          )} form-control-icon col-12 col-md-6`}
                          value={item.birth_certificate_file}
                          disabled={!disabled}
                          imageText={t(
                            'basic_data.with_income.attachment.text_11'
                          )}
                          showError={showError}
                          validations={[]}
                          label={t('basic_data.with_income.attachment.text_11')}
                        />
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.birth_date
                          )} form-control-icon col-12 col-md-6`}
                          disabled={disabled}
                          placeholder={t(
                            'register_applicant.placeholder.birthDate'
                          )}
                          value={formatDateOnly(item.birth_date)}
                          onChange={() => {}}
                          showError={showError}
                          validations={[]}
                          label={t('register_applicant.placeholder.birthDate')}
                          type=""
                        />
                      </div>
                      <ConditionalRender condition={!!item.live_separately}>
                        <div className="row">
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.family_benefits_file
                            )} form-control-icon col-12 col-md-6`}
                            value={item.family_benefits_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.placeholder.text_28'
                            )}
                            showError={
                              item.family_benefits_date_proof
                                ? showError
                                : false
                            }
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_28'
                            )}
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.family_benefits_date_proof
                            )} form-control-icon col-12 col-md-6`}
                            disabled={disabled}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_27'
                            )}
                            value={formatDateOnly(
                              item.family_benefits_date_proof as Date
                            )}
                            onChange={() => {}}
                            showError={
                              item.family_benefits_file ? showError : false
                            }
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_27'
                            )}
                            type=""
                          />
                        </div>
                      </ConditionalRender>
                      <ConditionalRender condition={!item.live_separately}>
                        <div className="row">
                          <StandardInput
                            type="text"
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.street
                            )} form-control-icon col-12`}
                            placeholder={t(
                              'register_applicant.placeholder.street'
                            )}
                            label={t('register_applicant.placeholder.street')}
                            value={item.street as string}
                            showError={showError}
                            onChange={() => {}}
                            disabled={disabled}
                            validations={[]}
                          />
                        </div>
                        <div className="row">
                          <StandardInput
                            type="text"
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.zip_code
                            )} form-control-icon col-12 col-md-6`}
                            placeholder={t(
                              'register_applicant.placeholder.zip'
                            )}
                            label={t('register_applicant.placeholder.zip')}
                            maxLength={4}
                            value={item.zip_code as number}
                            showError={showError}
                            onChange={() => {}}
                            disabled={disabled}
                            validations={[]}
                          />
                          <StandardInput
                            type="text"
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.location
                            )} form-control-icon col-12 col-md-6`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_23'
                            )}
                            label={t(
                              'basic_data.with_income.placeholder.text_23'
                            )}
                            disabled={disabled}
                            value={item.location as string}
                            showError={showError}
                            onChange={() => {}}
                            validations={[]}
                          />
                        </div>

                        <div className="row">
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.registration_form_file
                            )}`}
                            value={item.registration_form_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_12'
                            )}
                            showError={showError}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_12'
                            )}
                          />
                        </div>

                        <div className="row">
                          <div className="col-12 fs-14 fw-black my-1">
                            {capitalizeFirstLetter(
                              t('basic_data.with_income.general.text_6')
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.school_study_confirmation_file
                            )} col-12 col-md-6`}
                            value={item.school_study_confirmation_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_17'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_17'
                            )}
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.school_study_confirmation_date_proof
                            )} form-control-icon col-12 col-md-6`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            value={formatDateOnly(
                              item.school_study_confirmation_date_proof as Date
                            )}
                            onChange={() => {}}
                            disabled={disabled}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            type=""
                          />
                        </div>
                        <div className="row">
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.confirmation_of_co_insurance_file
                            )} col-12 col-md-6`}
                            value={item.confirmation_of_co_insurance_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_16'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_16'
                            )}
                          />

                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.confirmation_of_co_insurance_date_proof
                            )} form-control-icon col-12 col-md-6`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            value={formatDateOnly(
                              item.confirmation_of_co_insurance_date_proof as Date
                            )}
                            onChange={() => {}}
                            disabled={disabled}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            type=""
                          />
                        </div>
                        <div className="row">
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.basic_military_community_service_file
                            )} col-12 col-md-6`}
                            value={item.basic_military_community_service_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_14'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_14'
                            )}
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.basic_military_community_service_date_proof
                            )} form-control-icon col-12 col-md-6`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            value={formatDateOnly(
                              item.basic_military_community_service_date_proof as Date
                            )}
                            disabled={disabled}
                            onChange={() => {}}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            type=""
                          />
                        </div>
                        <div className="row">
                          <StandardCurrency
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.net_income_eur
                            )} form-control-icon col-12 col-md-4`}
                            placeholder={t(
                              'subsidy_calculation_with.message.value_3'
                            )}
                            disabled={disabled}
                            label={t(
                              'subsidy_calculation_with.message.value_3'
                            )}
                            value={item.net_income_eur as number}
                            showError={showError}
                            onChange={() => {}}
                            validations={[]}
                            type=""
                          />
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.proof_of_income_file
                            )} col-12 col-md-4`}
                            value={item.proof_of_income_file!}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.with_income.attachment.text_13'
                            )}
                            showError={false}
                            validations={[]}
                            label={t(
                              'basic_data.with_income.attachment.text_13'
                            )}
                          />
                          <StandardInput
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.proof_of_income_date_proof
                            )} form-control-icon col-12 col-md-4`}
                            placeholder={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            disabled={disabled}
                            value={formatDateOnly(
                              item.proof_of_income_date_proof as Date
                            )}
                            onChange={() => {}}
                            showError={
                              item.net_income_eur! > 0 ? showError : false
                            }
                            validations={[]}
                            label={t(
                              'basic_data.with_income.placeholder.text_4'
                            )}
                            type=""
                          />
                        </div>
                      </ConditionalRender>
                    </div>
                  );
                })}
              </ConditionalRender>
            </div>
          </div>
        </ConditionalRender>
      </div>
    </div>
  );
};
